module.exports = __webpack_public_path__ + "static/media/md-bicycle.c93a92ab.svg";